import { useEffect } from 'react';
import { User } from '@vtblife/event-bus-events';

import { setLastAuth } from '../helpers/last-auth';

export const useSyncAuthState = (user: User | null) => {
    useEffect(() => {
        setLastAuth({
            username: user?.username,
            isAuthorized: Boolean(user?.isAuthenticated),
            currentRoleType: user?.currentRoleType,
            userId: user?.userId,
        });
    }, [user]);
};
